<template>
  <div class="bg">
    <div class="container">
      <div class="header">
        <h3 class="hedtitle">
          {{ paper.paper && paper.paper.paperName }}
        </h3>
        <div class="lunbo">
          <img :src="logo" alt="" style="width: 100%; height: 100%" />
        </div>
      </div>
      <div class="content">
        <div class="test-main">
          <div class="test-main-left card">
            <div class="car-title bus">
              <span>当前学习课程</span>
            </div>
            <div
              class="test-main-left-con"
              v-for="(item, index) in paper.questionTypeDtoList"
              :key="index"
            >
              <h3 class="test-title">{{ item.typeName }}题</h3>
              <div class="test-num">
                <div
                  v-for="(myItem, myIndex) in item.questionList"
                  :class="display.index === item.str[myIndex] ? 'active' : ''"
                  :key="myIndex"
                  @click="
                    getQuestions(
                      $event.srcElement.innerText,
                      myItem,
                      item.typeName
                    )
                  "
                >
                  {{ item.str[myIndex] }}
                </div>
              </div>
            </div>
          </div>
          <div class="test-main-right card">
            <div class="test-main-right-content">
              <div class="text-right-title">
                <h3>试题</h3>
                <h4>
                  倒计时 <span>{{ showTime }}</span>
                </h4>
              </div>
              <div class="right-content-header">{{ type }}题</div>
              <div class="right-content-main">
                <question
                  v-if="display.questionDescription"
                  v-model="display"
                  :letter="letter"
                ></question>
              </div>
            </div>
            <div class="butons">
              <el-button
                class="bspd"
                @click="prevQuestion"
                v-if="display.index !== 1"
                >上一题</el-button
              >
              <el-button
                class="bspd"
                @click="nextQuestion"
                v-if="display.index !== array.length"
                >下一题
              </el-button>
              <el-button
                class="setjuan"
                :disabled="disabled"
                v-show="submit1 == false"
                plain
                @click="submit"
                >交卷</el-button
              >
            </div>

            <div v-show="show">
              <p style="margin-left: 20px; font-size: 24px; font-weight: bold">
                正确答案：
                <!-- {{
                  Array.isArray(display.answer)
                    ? display.answer.toString()
                    : display.answer
                }} -->
                <span v-for="(item, index) in display.answerList" :key="index">
                  <b v-if="item.isTrue">{{
                    ["A", "B", "C", "D", "E", "F", "G"][index]
                  }}</b>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";
import question from "@/components/question";
import * as moment from "moment";

export default {
  name: "index",
  data() {
    return {
      letter: "ABCDEFG",
      showTime: "",
      paperTime: "",
      paper: {},
      display: {},
      array: [],
      loading: false,
      questionsList: [],
      show: false,
      disabled: false,
      type: "",
      logo: "",
      classId: "",
      submit1: false,
      scorePass: null,
    };
  },
  components: {
    question,
  },
  mounted() {
    this.classId = this.$route.query.classId;
    api.classForId(this.$route.query.classId).then((res) => {
      this.logo = res.data.classContent;
      // console.log(res.data.classLogo)
    });
    api.getPaper(this.$route.query.paperId).then((res) => {
      // console.log(res.data)
      let number = 0;
      res.data.questionTypeDtoList.forEach((item) => {
        item.str = [];
        item.questionList.forEach((items) => {
          item.str.push(++number);
          this.array.push(items);
        });
      });
      this.paper = res.data;
      this.paperTime = res.data && res.data.paper && res.data.paper.paperTime;
      this.type = res.data.questionTypeDtoList[0].typeName;
      let id = res.data.questionTypeDtoList[0].questionList[0];
      this.getQuestion(id, 1);
      this.countdown();
      console.log(this.submit1);
      api.getClassHistory(cookie.getCookie("userId")).then((res) => {
        // console.log('getClassHistory', res)
        if (res.code === 200 && res.data) {
          res.data.length &&
            res.data.forEach((e) => {
              if (e.classConfigId === Number(this.classId)) {
                // console.log(e)
                api
                  .getTestHistory(e.statusId, { noToast: true })
                  .then((ret) => {
                    console.log("getTestHistory", ret);
                    if (ret.code === 200 && ret.data) {
                      this.scorePass = ret.data.scorePass;
                    }
                  });
              }
            });
        }
      });
    });
  },
  methods: {
    //倒计时
    countdown() {
      var endTime = moment().add(this.paperTime, "minutes");
      // console.log(moment.duration(1000, 'm'));
      console.log(endTime);
      this.set = setInterval(() => {
        const timeLeft = moment(endTime.diff(moment()));
        this.showTime = timeLeft.utc().format("HH:mm:ss");
        // console.log(timeLeft, this.showTime)
        if (timeLeft <= 0) {
          clearTimeout(this.set);
          this.submit();
          return false;
        }
      }, 1000);

      // var downTime = moment.duration(this.paperTime, "minutes").format('HH:mm:ss');
      // console.log(this.paperTime, downTime);
      // let midStr;
      // let firstStr;
      // this.set = setInterval(() => {
      //   downTime.subtract(1, "seconds");
      //   if (downTime.seconds() < 10) midStr = ":0";
      //   else midStr = ":";
      //   if (downTime.minutes() < 10) firstStr = "0";
      //   else firstStr = "";
      //   this.showTime =
      //     firstStr + downTime.minutes() + midStr + downTime.seconds();
      //   if (downTime.asSeconds() <= 0) {
      //     clearTimeout(this.set);
      //     this.submit();
      //     return false;
      //   }
      // }, 1000);
    },
    getQuestion(id, number) {
      api
        .getQuestion(id)
        .then((res) => {
          // console.log(res.data)
          let json = {
            index: number,
            id: id,
            questionType: res.data.questionType,
            questionDescription: res.data.questionDescription,
            answerList: res.data.questionAnswerList,
            isTrue: [],
            answer: "",
          };
          this.display = json;
          this.questionsList[number - 1] = json;
          for (let i = 0; i < res.data.answerList.length; i++) {
            if (res.data.questionType === 1) {
              if (res.data.answerList[i].isTrue === 1) {
                this.display.answer = this.letter[i];
              }
            } else if (res.data.questionType === 2) {
              if (res.data.answerList[i].isTrue === 1) {
                this.display.answer += this.letter[i];
              }
            } else {
              return false;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    prevQuestion() {
      let type;
      this.paper.questionTypeDtoList.forEach((item) => {
        item.questionList.forEach((items) => {
          if (items === this.array[this.display.index - 2]) {
            type = item.typeName;
          }
        });
      });
      this.getQuestions(
        this.display.index - 1,
        this.array[this.display.index - 2],
        type
      );
    },
    nextQuestion() {
      let type;
      this.paper.questionTypeDtoList.forEach((item) => {
        item.questionList.forEach((items) => {
          if (items === this.array[this.display.index]) {
            type = item.typeName;
          }
        });
      });
      this.getQuestions(
        this.display.index + 1,
        this.array[this.display.index],
        type
      );
    },
    getQuestions(e, id, type) {
      let select;
      this.paper.questionTypeDtoList.forEach((item) => {
        if (item.typeName === type) {
          this.type = item.typeName;
        }
      });
      if (
        this.questionsList.some((item, index) => {
          select = index;
          return item.id === id;
        })
      ) {
        this.display = this.questionsList[select];
      } else {
        let number = typeof e === "string" ? Number(e) : e;
        this.getQuestion(id, number);
      }
    },
    submit() {
      this.show = true;
      this.disabled = true;
      let form = {
        paperId: this.paper.paper.paperId,
        userId: cookie.getCookie("userId"),
        classId: this.classId,
        answerList: [],
        testTime: this.paper.paper.paperTime,
      };
      // console.log(form);
      clearTimeout(this.set);
      this.questionsList.forEach((item) => {
        // console.log(this.display)
        let arr = [];
        if (Array.isArray(item.isTrue)) {
          arr = item.isTrue;
        } else {
          arr.push(item.isTrue);
        }
        form.answerList.push({
          answerId: arr,
          questionId: item.id,
        });
        if (item.questionType == 1) {
          if (item.answerList[0].isTrue == 1) {
            item.answer = "A";
          } else if (item.answerList[1].isTrue == 1) {
            item.answer = "B";
          } else if (item.answerList[2] && item.answerList[2].isTrue == 1) {
            item.answer = "C";
          } else if (item.answerList[3] && item.answerList[3].isTrue == 1) {
            item.answer = "D";
          }
        } else {
          item.answer = [];
          if (item.answerList[0].isTrue == 1) {
            item.answer.push("A");
          }
          if (item.answerList[1] && item.answerList[1].isTrue == 1) {
            item.answer.push("B");
          }
          if (item.answerList[2] && item.answerList[2].isTrue == 1) {
            item.answer.push("C");
          }
          if (item.answerList[3] && item.answerList[3].isTrue == 1) {
            item.answer.push("D");
          }
          // console.log(item.answerList.length)
          if (item.answerList.length == 5) {
            // console.log("jin111")
            if (item.answerList[4].isTrue == 1) {
              item.answer.push("E");
            }
          }
          if (item.answerList.length == 6) {
            if (item.answerList[5].isTrue == 1) {
              item.answer.push("F");
            }
          }
          if (item.answerList.length == 7) {
            if (item.answerList[6].isTrue == 1) {
              item.answer.push("G");
            }
          }
        }
      });
      api
        .submitPaper(form)
        .then((res) => {
          console.log("submitPaper", res);
          let str =
            res.data.score >= (this.scorePass ? this.scorePass : 80)
              ? "，恭喜你通过考试"
              : "，很遗憾你未通过考试";
          let alertStr =
            "测试得分为" +
            res.data.score +
            "分" +
            (this.scorePass && this.scorePass > 100 ? "" : str) +
            "，考试结束。<br/>请勿关闭考试界面，可查看参考答案。";
          // console.log(str, alertStr);
          this.$alert(alertStr, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            callback: () => {
              window.open("https://www.wjx.cn/vj/YiofVy9.aspx");
            },
          });
        })
        .catch(() => {
          this.$message.error("提交失败");
        });
      console.log(this.questionsList);
      this.submit1 = true;
    },
  },
  beforeDestroy() {
    clearTimeout(this.set);
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 20px 0px;
  .header {
    .hedtitle {
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      text-align: center;
      margin: 0px;
    }
    .lunbo {
      width: 1200px;
      height: 100px;
      margin: 16px auto 0px;
    }
  }

  .content {
    width: 1200px;
    margin: 0px auto;
    padding: 20px;
    min-height: 700px;
  }
}

.card {
  width: 1200px;
  background: #ffffff;
  padding: 24px 20px;
  .car-title {
    position: relative;
    text-align: left;
    padding-left: 8px;
    height: 22px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #264f99;
    line-height: 22px;
    text-align: justify;
    font-style: normal;
  }
  .car-title::before {
    content: "";
    width: 4px;
    height: 12px;
    background: #264f99;
    display: block;
    position: absolute;
    top: 6px;
    left: 0px;
  }
}

.test-main {
  display: flex;
  justify-content: space-between;
}

.test-main-left {
  width: 340px;
  margin-right: 20px;
  box-sizing: border-box;
}

.bus {
  margin-bottom: 20px;
}

.test-main-left-con {
  margin-bottom: 20px;

  .test-title {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    margin: 0px;
    padding: 0px;
    margin-bottom: 6px;
  }

  .test-num {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 26px;
      height: 26px;
      background: #ffffff;
      text-align: center;
      line-height: 26px;
      border: 1px solid #cccccc;
      cursor: pointer;
      margin-right: 4px;
      margin-top: 4px;
      border-radius: 3px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      box-sizing: border-box;
    }
    div:nth-child(10n) {
      margin-right: 0px;
    }
    div.active {
      color: #fff;
      background: #264f99;
    }
  }
}

.test-main-right {
  flex: 1;
  overflow: hidden;
}

.test-main-right-content {
  // margin: 20px;
  .text-right-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eaeaeb;
    padding-bottom: 20px;
    h3,
    h4 {
      margin: 0px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
    }
    span {
      color: #264f99;
      font-weight: bold;
      padding-left: 10px;
      font-size: 20px;
      line-height: 22px;
      vertical-align: text-top;
    }
  }
  .right-content-header {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    text-align: justify;
    font-style: normal;
    margin: 20px 0px;
  }
}

.test-main-right-content > p {
  border-bottom: 1px solid #d5d5d5;
  padding-bottom: 10px;
  font-size: 16px;
  color: #000000;
  height: 18px;
  line-height: 18px;
}

.right-content-main > p {
  font-size: 14px;
  color: #0d253e;
  font-weight: 700;
}

.right-content-main .question-info {
  margin: 20px 0;
  line-height: 24px;
}

.right-content-main .question-info p:first-child {
  float: left;
}

.right-content-main .question-info p + p {
  margin-left: 2em;
}

.butons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 45px;
  .bspd {
    width: 140px;
    height: 42px;
    background: #dfe5f0;
    border-radius: 4px;
    color: #264f99;
  }
  .setjuan {
    width: 140px;
    height: 42px;
    background: #264f99;
    border-radius: 4px;
    color: #ffffff;
  }
}
</style>
